export default __webpack_public_path__ + "static/media/cderp_v2.525b7d51.jpg";